import { SearchOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Row, Col, Modal } from 'antd';
import moment from 'moment';
import { resetSearchValue } from 'pages/ListMachine/slices';
import { getDetailMachine } from 'pages/ListMachine/thunk';
import { filterListPatient } from 'pages/MachineUpdate/thunk';
import { FC, useState } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { RootState } from 'store';
import { HeaderTitle, BackToPrevMachine, Rectangle } from 'components';
import Wrap from './styles';
import { endLease } from './thunk';

const MachineDetail: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<{ itemId: string }>();
  const { itemDetail, listPatient } = useSelector((state: RootState) => state.machine);
  const leaseContractIdItem = itemDetail?.lease_contract_id;
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);

  useEffect(() => {
    if (location.state) {
      dispatch(getDetailMachine(location.state.itemId));
    }
  }, [dispatch, location.state]);
  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/machine' && history.location.pathname !== '/machine/edit') {
        dispatch(resetSearchValue());
      }
    };
  }, [dispatch, history.location.pathname]);
  useEffect(() => {
    if (leaseContractIdItem) {
      dispatch(filterListPatient(leaseContractIdItem));
    }
  }, [dispatch, leaseContractIdItem]);
  const ListMachine = () => {
    history.push('/machine');
  };
  const EditMachine = () => {
    history.push('/machine/edit', { itemId: itemDetail?.i_id });
  };
  const UpdateMachine = () => {
    history.push('/machine/update', { itemId: itemDetail?.i_id });
  };
  const DetailAfterEndLease = async () => {
    if (successModal) {
      setModalVisible(false);
      history.push('/machine/detail-lease', { itemId: itemDetail?.i_id });
      return;
    }
    const param = {
      item:
        {
          i_id: itemDetail?.i_id,
          d_id: itemDetail?.d_id,
          machine_quantity: itemDetail?.machine_quantity && +itemDetail?.machine_quantity,
        } || {},
      machine: itemDetail?.machines,
      return_item_result: true,
    };
    const result: any = await dispatch(endLease(param));
    if (!result.payload.error) {
      setSuccessModal(true);
    }
  };

  const LabelExpDate = useMemo(() => {
    const start = moment();
    const end = moment(itemDetail?.lease_end_date);
    if (end.diff(start, 'days') >= 50) {
      return null;
    }
    return (
      <Col className="alert-lease" span={4}>
        <ExclamationCircleOutlined />
        <span className="smallFont alert-text">リース契約終了間近</span>
      </Col>
    );
  }, [itemDetail]);

  const renderPatient = (machineId: string, arr: any[]) => {
    const listPatientOfMachine = arr?.filter((patient: any) => patient.machine_id === machineId);
    const patients = listPatientOfMachine?.filter((name: any) => name.suspension_flg !== 1);
    let namePatient = patients.reduce(function (previousValue, currentValue, index, array) {
      const nameFactility = currentValue.facility_name ?? '';
      let patient = nameFactility.concat(' ', currentValue.patient_name);
      if (index < array.length - 1) {
        patient += ', ';
      }
      return previousValue + patient;
    }, '');
    return namePatient;
  };

  const ListDevices = useMemo(() => {
    return itemDetail?.machines?.map((value, index: number) => (
      <Row className="bd p-21">
        <Col className="ml-5" span={2}>
          {index + 1}
        </Col>
        <Col className="standardFont" span={3}>
          {value.machine_type_name}
        </Col>
        <Col className="standardFont" span={3}>
          {value.machine_other}
        </Col>
        <Col className="standardFont" span={4}>
          {value.machine_serial_number}
        </Col>
        <Col className="standardFont" span={6}>
          {renderPatient(value.machine_id?.toString() || '', listPatient ?? [])}
        </Col>
        <Col className="standardFont" span={4}>
          {value.machine_remark}
        </Col>
        <Col className="standardFont" span={2}>
          {(value.Status === 'Return' || value.Status === '返却') && (
            <div style={{ backgroundColor: '#eeeeee', textAlign: 'center', padding: '5px 8px' }}>返却</div>
          )}
        </Col>
      </Row>
    ));
  }, [itemDetail?.machines, listPatient]);

  if (!location.state) {
    return <Redirect to="/machine" />;
  }

  return (
    <Wrap>
      <HeaderTitle
        title={`${itemDetail?.purchased_equipment === '1' ? '購入機器情報詳細' : 'リース契約詳細'}`}
        icon={SearchOutlined}
      />
      <BackToPrevMachine backToPrev={ListMachine} />
      <div className="btn-business">
        {itemDetail?.Status === 'End of a contract' || itemDetail?.Status === '契約終了' ? (
          <Button className="btn-termination-of-lease standardBoldFont">リース契約終了</Button>
        ) : (
          <>
            {!itemDetail?.purchased_equipment && (
              <Button onClick={() => setModalVisible(true)} className="btn-mg btn-end-of-lease standardBoldFont">
                リース終了
              </Button>
            )}
            <Modal
              title="リース契約終了"
              centered
              width={675}
              closable={false}
              visible={modalVisible}
              onOk={() => DetailAfterEndLease()}
              okText={successModal ? '閉じる' : 'リース契約を終了する'}
              cancelText="キャンセル"
              onCancel={() => setModalVisible(false)}
              okButtonProps={{
                className: 'extraLargeFont',
                style: { textAlign: 'center', width: '256px', height: '60px' },
              }}
              cancelButtonProps={{ className: 'btnDefault' }}
            >
              <p
                className="middleBoldFont"
                style={{
                  width: '524px',
                  height: '72px',
                  textAlign: 'center',
                  margin: '0px auto',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {successModal ? (
                  'このリース契約を終了しました。'
                ) : (
                  <>
                    <span>リース契約を終了します。</span>
                    <span>この契約のリース機器はすべて返却処理し、患者とのリンクを外します。</span>
                    <span>よろしいですか？</span>
                  </>
                )}
              </p>
            </Modal>
            {!itemDetail?.purchased_equipment && (
              <Button onClick={() => UpdateMachine()} className="btn-mg btn-renew-lease standardBoldFont">
                リース期間を更新する
              </Button>
            )}
            <Button onClick={() => EditMachine()} className="btn-update-lease standardBoldFont">
              内容を修正する
            </Button>
          </>
        )}
      </div>
      <div className="info-lease">
        <div className="lease">
          <Rectangle text={`${itemDetail?.purchased_equipment === '1' ? '購入機器情報' : 'リース情報'}`} decor="bd" />
          <div className="statistics">
            <Row className="pb-16 bd">
              <Col className="standardBoldFont ml-5" span={5}>
                リース期間
              </Col>
              <Col className="standardFont" span={7}>
                {itemDetail?.lease_start_date && moment(itemDetail.lease_start_date).format('YYYY年MM月DD日')}
                {itemDetail?.lease_end_date && `〜${moment(itemDetail.lease_end_date).format('YYYY年MM月DD日')}`}
              </Col>
              {!itemDetail?.purchased_equipment && LabelExpDate}
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont ml-5" span={5}>
                契約日
              </Col>
              <Col className="standardFont" span={6}>
                {itemDetail?.lease_contract_date && moment(itemDetail.lease_contract_date).format('YYYY年MM月DD日')}
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont ml-5" span={5}>
                台数
              </Col>
              <Col className="standardFont" span={6}>
                {itemDetail?.machine_quantity}台
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont ml-5" span={5}>
                リース会社
              </Col>
              <Col className="standardFont" span={6}>
                {itemDetail?.lease_company}
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont ml-5" span={5}>
                販売店
              </Col>
              <Col className="standardFont" span={6}>
                {itemDetail?.lease_shop}
                {itemDetail?.lease_shop_other}
              </Col>
            </Row>
            <Row className="pb-16 pt-16">
              <Col className="standardBoldFont ml-5" span={5}>
                契約番号
              </Col>
              <Col className="standardFont" span={6}>
                {itemDetail?.lease_contract_id}
              </Col>
            </Row>
          </div>
        </div>
        <div className="statistics-editable">
          <Rectangle text={`${itemDetail?.purchased_equipment ? '購入機器一覧' : 'リース機器一覧'}`} decor="bd" />
          <div className="lease-equipment">
            <Row className="bd pb-10">
              <Col span={2} />
              <Col className="standardBoldFont" span={6}>
                機種
              </Col>
              <Col className="standardBoldFont" span={4}>
                シリアルナンバー
              </Col>
              <Col className="standardBoldFont" span={6}>
                患者名
              </Col>
              <Col className="standardBoldFont" span={4}>
                備考
              </Col>
              <Col className="standardBoldFont" span={2} />
            </Row>
            {ListDevices}
          </div>
        </div>
      </div>
    </Wrap>
  );
};
export default MachineDetail;
